import { TrackingHandler } from '../../tracking/TrackingHandler';
import { showExitModal } from './modal';
export const initExitHandling = () => {
    const trackingHandler = TrackingHandler.getInstance();
    document.addEventListener('mouseleave', (event) => {
        if (!trackingHandler.isSoftConversionTriggered()) {
            return;
        }
        if (event.y > 0) {
            return;
        }
        if (document.querySelector('modal.is-open .form-block')) {
            return;
        }
        showExitModal();
    });
};
